import type { SignupSummary } from 'api-client';

export interface SignupChartRow {
  date: string;
  count: number;
  cumulative: number;
}

export const buildSignupSeries = (summary: SignupSummary): SignupChartRow[] => {
  const counts = new Map(summary.signups.map((item) => [item.date.toISOString().slice(0, 10), item.count]));
  const current = new Date(summary.start.getTime());
  const rows: SignupChartRow[] = [];
  let cumulative = summary.startValue;
  while (current <= summary.end) {
    const date = current.toISOString().slice(0, 10);
    const count = counts.get(date) || 0;
    cumulative += count;
    rows.push({ date, count, cumulative });
    current.setUTCDate(current.getUTCDate() + 1);
  }
  return rows;
};
